import fetch from '@api/fetchers';
import { getCMSHost } from '@utils/api-helper/host';
import fetcher from '@api/fetchers/simpleFetcher';

const CMSHost = getCMSHost();

export const drawWOFSpin = (eventUID) =>
  fetch(`v1/common/fortune_draw/${eventUID}/grant_prize/`, {
    requestType: 'POST'
  });

export const fetchRewardEvent = ({ rewardKey }) =>
  fetcher(`${CMSHost}api/reward-events/${rewardKey}`);

export const fetchRewardPrizeDetails = (eventUID) =>
  fetch(`v1/common/fortune_draw/${eventUID}/prize_details`);
